import React from "react";

import { withWinterTimeRange } from "../../../shared/containers/containerWinterMaintenceTimeRange";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { states } from "../../../reducers/queriesStates";
import Preloader from "../../../shared/items/static/preloader";

const getDate = (date, time) => {
  const dateTime = new Date(date);
  const _time = new Date(time);
  dateTime.setHours(_time.getHours());
  dateTime.setMinutes(_time.getMinutes());
  dateTime.setSeconds(0);
  dateTime.setMilliseconds(0);

  return dateTime;
};

const getIntellegenceData = (props) => {
  const {
    rangeStartDate,
    rangeEndDate,
    rangeStartTime,
    rangeEndTime,
    winterAreas,
    onGetWinterCompaniesRoutes,
    isReportMode,
    onWinterReportDownload,
    searchGeoZone,
  } = props;

  const startDate = getDate(rangeStartDate, rangeStartTime);
  const endDate = getDate(rangeEndDate, rangeEndTime);

  const companies = [];

  winterAreas.forEach((area) => {
    area.parentCompanies.forEach((parentCompany) => {
      parentCompany.companies.forEach((company) => {
        companies.push(company);
      });
    });
  });

  if (!isReportMode) {
    onGetWinterCompaniesRoutes(companies, { startDate, endDate, searchGeoZone });
  } else {
    onWinterReportDownload({ startDate, endDate });
  }
};

const WinterMaintenceButtonWrapper = (props) => {
  const { disabled, winterCompaniesRoutesDataState, winterRouteUnitsProcess } = props;

  if (winterCompaniesRoutesDataState === states.REQUEST) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "140px", position: "relative" }}>
        <Preloader />
        <div style={{ paddingLeft: "2px", fontSize: "15px", fontWeight: "600", position: "absolute" }}>{`${winterRouteUnitsProcess}%`}</div>
      </div>
    );
  }

  return <ButtonPrimary handleClick={getIntellegenceData.bind(this, props)} title="Показать" disabled={disabled} />;
};

export default withWinterTimeRange(withWinterMaintence(React.memo(WinterMaintenceButtonWrapper)));
